import {
	getLocalData,
	setLocalData,
	isEmpty
} from '@/utils/util'

const TokenKey = 'key_token'
var token = ''

export function getToken() {
	if (isEmpty(token)) {
		token = getLocalData(TokenKey)
	}

	return token
}

export function setToken(newToken) {
	token = newToken
	return setLocalData(TokenKey, newToken)
}